import React, { useEffect } from "react";
import { FolderRegular } from "@fluentui/react-icons";
import { useMount } from "react-use";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

import PageHeader from "../../../components/Headings/PageHeader";
import Filing from "../../../components/Filing";
import useOfficeContext from "../../../hooks/useOfficeContext";
import { useFilingContext } from "../../../contexts/FilingContext";
// import { getMockSuggestions } from "../../../mockFilingSuggestions";
import { pageContainerClass } from "./styles";

const File: React.FC = () => {
  const appInsights = useAppInsightsContext();
  const { itemIds } = useOfficeContext();
  const { setSuggestedFolders } = useFilingContext();

  useEffect(() => {
    // getMockSuggestions(itemIds[0]).then(setSuggestedFolders);
  }, [itemIds]);

  useMount(() => {
    appInsights.trackPageView({ name: "File" });
  });

  return (
    <div className={pageContainerClass}>
      <PageHeader headingText={`File ${itemIds.length === 1 ? "Message" : "Messages"}`} icon={<FolderRegular />} />
      <Filing itemIds={itemIds} />
    </div>
  );
};

export default File;
